<template>
  <div style="margin-top: 50px">
    <el-table :data="ItemArr" style="width: 100%; text-align: center">
      <el-table-column prop="Title" label="职位名称"  width="180">
      </el-table-column>
      <el-table-column prop="Company" label="招聘公司" width="300"></el-table-column>
      <el-table-column prop="jobType" label="职位类别"> </el-table-column>
      <!-- <el-table-column prop="jobCount" label="招聘人数"> </el-table-column> -->
      <el-table-column prop="ShowTime" label="发布时间"> </el-table-column>
      <el-table-column label="职位详情">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="LookInfo(scope.$index, scope.row)"
            ><i class="el-icon-right"></i
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  <script>
export default {
  props:{
    ItemArr:{
      default:Array
    }
  },
  data() {
    return {
    };
  },
  methods: {
    LookInfo(i,obj) {
      this.$emit('TapClick',obj.ID)
    }
  },
};
</script>